(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["AddressFormConfigurator"] = factory();
	else
		root["AddressFormConfigurator"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _formConfig = __webpack_require__(1);
	
	function getConfigByCountry() {
	  var country = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";
	
	  if (typeof country === 'string') {
	    country = country.toUpperCase();
	    if (_formConfig.formByCountryConfig[country]) {
	
	      return _formConfig.formByCountryConfig[country];
	    }
	    var countryGroup = _formConfig.countriesGroup.find(function (group) {
	      return group.countriesList.indexOf(country) !== -1;
	    });
	    if (countryGroup) {
	      return _formConfig.formByCountryConfig[countryGroup.configRel];
	    }
	  }
	  return _formConfig.formByCountryConfig.DEFAULT;
	}
	
	function getTwoLineAddressfieldByCountry() {
	  var country = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";
	
	  if (typeof country === 'string') {
	    country = country.toUpperCase();
	    if (_formConfig.twoLineAdressByCountryConfig[country]) {
	      return _formConfig.twoLineAdressByCountryConfig[country];
	    }
	  }
	  return _formConfig.twoLineAdressByCountryConfig.DEFAULT;
	}
	
	function isStreetFirst(country) {
	  if (typeof country === 'string') {
	    country = country.toUpperCase();
	    return _formConfig.streetFieldContentOrder.countryList.indexOf(country) !== -1;
	  }
	  return null;
	}
	
	function getRegions(country) {
	  if (typeof country === 'string') {
	    country = country.toUpperCase();
	    if (_formConfig.regionsByCountry[country]) {
	      return _formConfig.regionsByCountry[country];
	    }
	  }
	  return null;
	}
	
	var AddressFormConfigurator = {
	  getConfigByCountry: getConfigByCountry,
	  getTwoLineAddressfieldByCountry: getTwoLineAddressfieldByCountry,
	  isStreetFirst: isStreetFirst,
	  getRegions: getRegions
	};
	exports.default = AddressFormConfigurator;

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = {
		"streetFieldContentOrder": {
			"countryList": [
				"ES",
				"IT",
				"DE",
				"PT",
				"NL",
				"GR",
				"PL",
				"SE",
				"NO",
				"DK",
				"CZ",
				"HR",
				"RU",
				"TR",
				"BG",
				"SI",
				"UA",
				"BR",
				"TR"
			],
			"isStreetNameFirst": true
		},
		"formByCountryConfig": {
			"US": {
				"address1": {
					"posIndex": 1,
					"required": true,
					"label": "address1"
				},
				"address2": {
					"posIndex": 2,
					"required": false,
					"label": "address2"
				},
				"city": {
					"posIndex": 3,
					"required": true,
					"label": "city"
				},
				"stateProvince": {
					"posIndex": 4,
					"required": true,
					"label": "stateProvince"
				},
				"postalCode": {
					"posIndex": 5,
					"required": true,
					"label": "postalCode"
				}
			},
			"EU": {
				"address1": {
					"posIndex": 1,
					"required": true,
					"label": "address1"
				},
				"address2": {
					"posIndex": 2,
					"required": false,
					"label": "address2"
				},
				"city": {
					"posIndex": 4,
					"required": true,
					"label": "city"
				},
				"postalCode": {
					"posIndex": 3,
					"required": true,
					"label": "postalCode"
				}
			},
			"AU": {
				"address1": {
					"posIndex": 1,
					"required": true,
					"label": "address1"
				},
				"address2": {
					"posIndex": 2,
					"required": false,
					"label": "address2"
				},
				"city": {
					"posIndex": 3,
					"required": true,
					"label": "city"
				},
				"stateProvince": {
					"posIndex": 4,
					"required": true,
					"label": "stateProvince"
				},
				"postalCode": {
					"posIndex": 5,
					"required": true,
					"label": "postalCode"
				}
			},
			"GB": {
				"address1": {
					"posIndex": 1,
					"required": true,
					"label": "address1"
				},
				"address2": {
					"posIndex": 2,
					"required": false,
					"label": "address2"
				},
				"city": {
					"posIndex": 3,
					"required": true,
					"label": "city"
				},
				"postalCode": {
					"posIndex": 4,
					"required": true,
					"label": "postalCode"
				}
			},
			"MX": {
				"address1": {
					"posIndex": 1,
					"required": true,
					"label": "address1"
				},
				"address2": {
					"posIndex": 2,
					"required": false,
					"label": "address2"
				},
				"city": {
					"posIndex": 4,
					"required": true,
					"label": "city"
				},
				"stateProvince": {
					"posIndex": 5,
					"required": true,
					"label": "stateProvince"
				},
				"postalCode": {
					"posIndex": 3,
					"required": true,
					"label": "postalCode"
				}
			},
			"CA": {
				"address1": {
					"posIndex": 1,
					"required": true,
					"label": "address1"
				},
				"address2": {
					"posIndex": 2,
					"required": false,
					"label": "address2"
				},
				"city": {
					"posIndex": 3,
					"required": true,
					"label": "city"
				},
				"stateProvince": {
					"posIndex": 4,
					"required": true,
					"label": "stateProvince"
				},
				"postalCode": {
					"posIndex": 5,
					"required": true,
					"label": "postalCode"
				}
			},
			"PR": {
				"address1": {
					"posIndex": 1,
					"required": true,
					"label": "address1"
				},
				"address2": {
					"posIndex": 2,
					"required": false,
					"label": "address2"
				},
				"city": {
					"posIndex": 3,
					"required": true,
					"label": "city"
				},
				"postalCode": {
					"posIndex": 4,
					"required": true,
					"label": "postalCode"
				}
			},
			"VI": {
				"address1": {
					"posIndex": 1,
					"required": true,
					"label": "address1"
				},
				"address2": {
					"posIndex": 2,
					"required": false,
					"label": "address2"
				},
				"city": {
					"posIndex": 3,
					"required": true,
					"label": "city"
				},
				"postalCode": {
					"posIndex": 4,
					"required": true,
					"label": "postalCode"
				}
			},
			"CN": {
				"address1": {
					"posIndex": 1,
					"required": true,
					"label": "address1"
				},
				"address2": {
					"posIndex": 2,
					"required": false,
					"label": "address2"
				},
				"city": {
					"posIndex": 3,
					"required": true,
					"label": "city"
				},
				"stateProvince": {
					"posIndex": 4,
					"required": false,
					"label": "province"
				},
				"postalCode": {
					"posIndex": 5,
					"required": true,
					"label": "postalCode"
				}
			},
			"JP": {
				"postalCode": {
					"posIndex": 1,
					"required": true,
					"label": "postalCode"
				},
				"stateProvince": {
					"posIndex": 2,
					"required": true,
					"label": "prefecture"
				},
				"city": {
					"posIndex": 3,
					"required": false,
					"label": "city"
				},
				"address1": {
					"posIndex": 4,
					"required": true,
					"label": "address1"
				},
				"address2": {
					"posIndex": 5,
					"required": false,
					"label": "address2"
				}
			},
			"STREETCITYPOSTALCODEREQUIRED": {
				"address1": {
					"posIndex": 1,
					"required": true,
					"label": "address1"
				},
				"address2": {
					"posIndex": 2,
					"required": false,
					"label": "address2"
				},
				"city": {
					"posIndex": 3,
					"required": true,
					"label": "city"
				},
				"stateProvince": {
					"posIndex": 4,
					"required": false,
					"label": "stateProvince"
				},
				"postalCode": {
					"posIndex": 5,
					"required": true,
					"label": "postalCode"
				}
			},
			"DEFAULT": {
				"address1": {
					"posIndex": 1,
					"required": true,
					"label": "address1"
				},
				"address2": {
					"posIndex": 2,
					"required": false,
					"label": "address2"
				},
				"city": {
					"posIndex": 3,
					"required": true,
					"label": "city"
				},
				"stateProvince": {
					"posIndex": 4,
					"required": false,
					"label": "stateProvince"
				},
				"postalCode": {
					"posIndex": 5,
					"required": false,
					"label": "postalCode"
				}
			}
		},
		"twoLineAdressByCountryConfig": {
			"JP": {
				"line1": {
					"country": {
						"posIndex": 1,
						"required": true
					},
					"postalCode": {
						"posIndex": 2,
						"required": true
					},
					"stateProvince": {
						"posIndex": 3,
						"required": true
					}
				},
				"line2": {
					"city": {
						"posIndex": 1,
						"required": false
					},
					"address1": {
						"posIndex": 2,
						"required": true
					},
					"address2": {
						"posIndex": 3,
						"required": false
					}
				}
			},
			"DEFAULT": {
				"line1": {
					"address1": {
						"posIndex": 1,
						"required": true
					},
					"address2": {
						"posIndex": 2,
						"required": false
					}
				},
				"line2": {
					"city": {
						"posIndex": 1,
						"required": true
					},
					"stateProvince": {
						"posIndex": 2,
						"required": true
					},
					"postalCode": {
						"posIndex": 3,
						"required": true
					},
					"country": {
						"posIndex": 4,
						"required": true
					}
				}
			}
		},
		"countriesGroup": [
			{
				"countriesList": [
					"FR",
					"ES",
					"IT",
					"DE",
					"PT",
					"HR",
					"GR",
					"AT",
					"NL",
					"CH",
					"CY",
					"DK",
					"BE",
					"SE",
					"CZ",
					"PL",
					"BG",
					"SG"
				],
				"configRel": "EU"
			},
			{
				"countriesList": [
					"AD",
					"AT",
					"AU",
					"BE",
					"BR",
					"BG",
					"CA",
					"CH",
					"CZ",
					"DE",
					"DK",
					"DO",
					"ES",
					"FR",
					"GB",
					"GR",
					"HR",
					"HU",
					"ID",
					"IN",
					"IT",
					"NL",
					"NZ",
					"PL",
					"PR",
					"SE",
					"SI",
					"TC",
					"TR",
					"US",
					"VI"
				],
				"configRel": "STREETCITYPOSTALCODEREQUIRED"
			}
		],
		"regionsByCountry": {
			"AU": {
				"ACT": "ACT",
				"NSW": "NSW",
				"NT": "NT",
				"QLD": "QLD",
				"SA": "SA",
				"TAS": "TAS",
				"VIC": "VIC",
				"WA": "WA"
			},
			"MX": {
				"AGS": "AGS",
				"BCN": "BCN",
				"BCS": "BCS",
				"CAM": "CAM",
				"CHIS": "CHIS",
				"CHIH": "CHIH",
				"COAH": "COAH",
				"COL": "COL",
				"CDMX": "CDMX",
				"DGO": "DGO",
				"GTO": "GTO",
				"GRO": "GRO",
				"HGO": "HGO",
				"JAL": "JAL",
				"MEX": "MEX",
				"MICH": "MICH",
				"MOR": "MOR",
				"NAY": "NAY",
				"NL": "NL",
				"OAX": "OAX",
				"PUE": "PUE",
				"QRO": "QRO",
				"QROO": "QROO",
				"SLP": "SLP",
				"SIN": "SIN",
				"SON": "SON",
				"TAB": "TAB",
				"TAMPS": "TAMPS",
				"TLAX": "TLAX",
				"VER": "VER",
				"YUC": "YUC",
				"ZAC": "ZAC"
			},
			"CA": {
				"AB": "AB",
				"BC": "BC",
				"MB": "MB",
				"NB": "NB",
				"NL": "NL",
				"NT": "NT",
				"NS": "NS",
				"NU": "NU",
				"ON": "ON",
				"PE": "PE",
				"QC": "QC",
				"SK": "SK",
				"YT": "YT"
			},
			"IE": {
				"Antrim": "Antrim",
				"Armagh": "Armagh",
				"Carlow": "Carlow",
				"Cavan": "Cavan",
				"Clare": "Clare",
				"Cork": "Cork",
				"Derry": "Derry",
				"Donegal": "Donegal",
				"Down": "Down",
				"Dublin": "Dublin",
				"Fermanagh": "Fermanagh",
				"Galway": "Galway",
				"Kerry": "Kerry",
				"Kildare": "Kildare",
				"Kilkenny": "Kilkenny",
				"Laois": "Laois",
				"Leitrim": "Leitrim",
				"Limerick": "Limerick",
				"Longford": "Longford",
				"Louth": "Louth",
				"Mayo": "Mayo",
				"Meath": "Meath",
				"Monaghan": "Monaghan",
				"Offaly": "Offaly",
				"Roscommon": "Roscommon",
				"Sligo": "Sligo",
				"Tipperary": "Tipperary",
				"Tyrone": "Tyrone",
				"Waterford": "Waterford",
				"Westmeath": "Westmeath",
				"Wexford": "Wexford",
				"Wicklow": "Wicklow"
			},
			"US": {
				"AL": "AL",
				"AK": "AK",
				"AZ": "AZ",
				"AR": "AR",
				"AA": "AA",
				"AE": "AE",
				"AP": "AP",
				"CA": "CA",
				"CO": "CO",
				"CT": "CT",
				"DE": "DE",
				"DC": "DC",
				"FL": "FL",
				"GA": "GA",
				"HI": "HI",
				"ID": "ID",
				"IL": "IL",
				"IN": "IN",
				"IA": "IA",
				"KS": "KS",
				"KY": "KY",
				"LA": "LA",
				"ME": "ME",
				"MD": "MD",
				"MA": "MA",
				"MI": "MI",
				"MN": "MN",
				"MS": "MS",
				"MO": "MO",
				"MT": "MT",
				"NE": "NE",
				"NV": "NV",
				"NH": "NH",
				"NJ": "NJ",
				"NM": "NM",
				"NY": "NY",
				"NC": "NC",
				"ND": "ND",
				"OH": "OH",
				"OK": "OK",
				"OR": "OR",
				"PA": "PA",
				"RI": "RI",
				"SC": "SC",
				"SD": "SD",
				"TN": "TN",
				"TX": "TX",
				"UT": "UT",
				"VT": "VT",
				"VA": "VA",
				"WA": "WA",
				"WV": "WV",
				"WI": "WI",
				"WY": "WY"
			}
		}
	};

/***/ }
/******/ ])
});
;
//# sourceMappingURL=stab-address-form-configurator.js.map